// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1IZU_","paramInput":"JobSimulator_paramInput__2q92v","input":"JobSimulator_input__3M8Wn"};